import PasswordInput from '@/components/PasswordInput';
import { FormControl, FormField, FormItem, FormMessage } from '@eye-able/ui';
import type { ChangeEvent } from 'react';
import type { ControllerRenderProps } from 'react-hook-form';
import type { UseFormReturn } from 'react-hook-form';

import type { ChangePasswordFormValues } from './types';

interface PasswordFieldProps {
  form: UseFormReturn<ChangePasswordFormValues>;
  name: keyof ChangePasswordFormValues;
  label: string;
  autoComplete: string;
  required: boolean;
  disabled: boolean;
  autoFocus?: boolean;
  validate?: (value: string) => string | true;
  onValueChange?: () => void;
}

type PasswordFieldRenderProps = {
  field: ControllerRenderProps<
    ChangePasswordFormValues,
    keyof ChangePasswordFormValues
  >;
};

function PasswordField({
  form,
  name,
  label,
  autoComplete,
  required,
  disabled,
  autoFocus = false,
  validate,
  onValueChange,
}: PasswordFieldProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      rules={{
        validate,
      }}
      render={({ field }: PasswordFieldRenderProps) => (
        <FormItem>
          <FormControl>
            <PasswordInput
              {...field}
              label={label}
              required={required}
              autoComplete={autoComplete}
              autoFocus={autoFocus}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                field.onChange(event.target.value);
                onValueChange?.();
              }}
              disabled={disabled}
            />
          </FormControl>
          {/* Read through the focused field (aria-describedby). As alerts,
              all messages would be announced at once on submit. */}
          <FormMessage role={undefined} aria-live={undefined} />
        </FormItem>
      )}
    />
  );
}

export default PasswordField;
